import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
import { Reveal, SectionHeading } from './Reveal';
import { FAQS } from '../data/content';

const FaqItem = ({ item, i, open, onToggle }) => (
  <Reveal delay={i * 0.05}>
    <div className="border-b border-white/10">
      <button
        data-testid={`faq-question-${i}`}
        onClick={onToggle}
        aria-expanded={open}
        className="group flex w-full items-center justify-between gap-6 py-6 text-left"
      >
        <span className={`font-display text-lg tracking-tight transition-colors duration-300 md:text-xl ${open ? 'text-gold' : 'text-white group-hover:text-gold'}`}>
          {item.q}
        </span>
        <span className={`flex h-9 w-9 shrink-0 items-center justify-center border transition-all duration-500 ${open ? 'rotate-45 border-gold text-gold' : 'border-white/15 text-white/60 group-hover:border-gold group-hover:text-gold'}`}>
          <Plus className="h-4 w-4" />
        </span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            data-testid={`faq-answer-${i}`}
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.45, ease: [0.76, 0, 0.24, 1] }}
            className="overflow-hidden"
          >
            <p className="max-w-3xl pb-7 text-sm font-light leading-relaxed text-white/55 md:text-base">{item.a}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  </Reveal>
);

const Faq = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="scroll-mt-24 border-y border-white/5 bg-[#0a0a0a] py-28 lg:py-36">
      <div className="mx-auto max-w-5xl px-6 lg:px-10">
        <SectionHeading eyebrow="FAQ" title={<>Answers, before<br /><span className="italic text-gold">you ask.</span></>} />
        <div className="border-t border-white/10">
          {FAQS.map((f, i) => (
            <FaqItem key={f.q} item={f} i={i} open={open === i} onToggle={() => setOpen(open === i ? -1 : i)} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
